<template>
  <Teleport to="body">
    <UIBaseTransition name="fade">
      <Component
        :is="UIStore.getDynamicMobilePanel.component"
        v-bind="UIStore.getDynamicMobilePanel.data"
        v-model="UIStore.getDynamicMobilePanel.value"
        v-on="UIStore.getDynamicMobilePanel.events"
        @update:model-value="UIStore.cleanMobilePanel"
      />
    </UIBaseTransition>
  </Teleport>
</template>

<script setup lang="ts">
import useUIStore from '@/store/ui'

const UIStore = useUIStore()
</script>

<style scoped></style>
